import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  styled,
  Button,
  IconButton,
  Rating,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { OpenInNew } from "@mui/icons-material";
import Testimonial1 from "../../images/testimonial 1.png";
import Testimonial2 from "../../images/testimonial-2.png";
import Testimonial3 from "../../images/testimonial-3.png";
import Testimonial4 from "../../images/testimonial-4.png";
import Testimonial5 from "../../images/testimonial-5.png";
import Testimonial6 from "../../images/testimonial-6.png";
import Testimonial7 from "../../images/testimonial-7.png";
import Testimonial8 from "../../images/testimonial-8.png";
import Testimonial9 from "../../images/testimonial-9.png";

export const Title = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 700,
  fontSize: "40px",
  color: "#4CAF50",
  [theme.breakpoints.down("md")]: {
    fontSize: "30px",
    textAlign: "center",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
    textAlign: "center",
  },
}));

const Text = styled(Typography)({
  fontFamily: "Raleway",
  fontWeight: 500,
  color: "#FFFFFF",
  fontSize: "16px",
  // minHeight: "180px",
});

const TextTitle = styled(Typography)({
  fontFamily: "Raleway",
  fontWeight: 600,
  color: "#14224B",
  fontSize: "18px",
});
const TextSubTitle = styled(Typography)({
  fontFamily: "Raleway",
  fontWeight: 600,
  color: "#1E4F6B",
  fontSize: "16px",
});

const LogoBox = styled(Box)({
  display: "flex",
  marginTop: "16px",
  alignItems: "flex-start",
  justifyContent: "flex-start",
});

const ItemBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  // padding: "16px",
  border: "1px solid #BCBCBC",
  background: "#4BAE4F",
  borderRadius: "12px",
  width: "100%",
  minHeight: "400px",
});

function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const testimonials = [
    {
      text: `"ManageKaro has revolutionized our inventory management at Super Machinery Store. I'm Mr. Haseeb, and this system has streamlined stock handling with unmatched efficiency. Its automation in tracking and reordering has cut manual work, saving time and eliminating errors in our records."`,
      rating: 5,
      image: Testimonial1,
      company: "SuperMachinery Store",
      address: "Rawalpindi",
    },
    {
      text: `"Before ManageKaro, I struggled to keep track of my daily sales and stock. Now, everything is automated, and I can see my profits in real-time. My sales have increased because I have better control over inventory and customer orders!"`,
      rating: 5,
      image: Testimonial2,
      company: "Salahuddin Collection",
      address: "Karachi",
    },
    {
      text: `"Managing accounts used to be a nightmare, but ManageKaro has simplified everything. I can generate invoices, track expenses, and even see customer balances in seconds. It’s like having a personal accountant!"`,
      rating: 5,
      image: Testimonial3,
      company: "Treet Corporation",
      address: "Peshawar",
    },
    {
      text: `"I always faced stock shortages because I couldn’t track what was selling fast. With ManageKaro, I get real-time stock updates and alerts when items are running low. This has saved me from losing sales!"`,
      rating: 5,
      image: Testimonial4,
      company: "Zohan Traders",
      address: "Sargodha",
    },
    {
      text: `"I used to spend hours on paperwork, but now, I manage everything on my phone. No more manual record-keeping or mistakes. ManageKaro has made my business more efficient and stress-free."`,
      rating: 5,
      image: Testimonial5,
      company: "Yasin Auto Parts",
      address: "Lahore",
    },
    {
      text: `"With ManageKaro, I can maintain a record of my regular customers, offer credit when needed, and send reminders for payments. This has improved my customer relationships and cash flow!"`,
      rating: 5,
      image: Testimonial6,
      company: "Ashraf Son's International Mobile Shop",
      address: "Lahore",
    },
    {
      text: `"Printing bills and invoices used to be a slow process, but now, with ManageKaro, I generate professional receipts instantly. My customers appreciate the quick service, and I love the convenience!"`,
      rating: 5,
      image: Testimonial7,
      company: "Al Harmain Sanitary",
      address: "Azad Kashmir",
    },
    {
      text: `"ManageKaro gives me detailed reports on sales, expenses, and profits, helping me make better business decisions. Since I started using it, I’ve improved my pricing strategy and increased my profits!"`,
      rating: 5,
      image: Testimonial8,
      company: "Madina Super Store",
      address: "Lahore",
    },
    {
      text: `"I run multiple shops, and it was hard to track sales and inventory across locations. With ManageKaro, I can monitor everything from my phone, making it easy to manage my business efficiently!"`,
      rating: 5,
      image: Testimonial9,
      company: "SKG International Distribution",
      address: "Lower Deer KPK",
    },
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
    );
  };

  // Auto-play functionality (to automatically change slides)
  // useEffect(() => {
  //   let timer;
  //   if (autoPlay && currentIndex < testimonials.length - 1) {
  //     timer = setInterval(() => {
  //       setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length); // Loop back to first testimonial
  //     }, 2500); // Change every 2.5 seconds
  //   } else {
  //     setAutoPlay(false); // Stop auto-play when we reach the last testimonial
  //   }

  //   return () => clearInterval(timer); // Clean up the timer when component unmounts
  // }, [autoPlay, currentIndex]); // Added currentIndex to dependencies
  useEffect(() => {
    let timer;
    if (autoPlay) {
      timer = setInterval(() => {
        setCurrentIndex((prevIndex) => {
          if (prevIndex >= testimonials.length - 1) {
            // Reset transition for seamless looping
            setTimeout(() => {
              setCurrentIndex(0);
            }, 500); // Small delay for smooth transition
            return prevIndex; // Stay at last index temporarily
          }
          return prevIndex + 1;
        });
      }, 2500); // Change every 2.5 seconds
    }

    return () => clearInterval(timer);
  }, [autoPlay, currentIndex]);

  return (
    <Box sx={{ pt: "40px" }}>
      <Title variant="h1" textAlign={"center"}>
        What our users are saying!
      </Title>

      <Box mt={5} sx={{ position: "relative", overflow: "hidden" }}>
        <Box
          sx={{
            display: "flex",
            transform: isSmall
              ? `translateX(-${
                  currentIndex === testimonials.length - 1
                    ? currentIndex * 25
                    : currentIndex * 99.5
                }%)`
              : `translateX(-${
                  currentIndex === testimonials.length - 1
                    ? currentIndex * 44
                    : currentIndex * 50
                }%)`,
            transition: "transform 0.5s ease",
          }}
        >
          {/* {testimonials.map((testimonial, index) => ( */}
          {testimonials.concat(testimonials).map((testimonial, index) => (
            <Box
              key={index}
              sx={{
                minWidth: isSmall ? "91%" : "668px",
                margin: isSmall ? "0 16px" : "0 20px",
              }}
            >
              <ItemBox
                sx={{
                  minWidth: isSmall ? "100%" : "400px",
                  minHeight: isSmall ? "530px" : "auto",
                }}
              >
                <Box
                  sx={{
                    height: "79px",
                    width: "78px",
                    borderRadius: "70px",
                    background: "#FFFFFF",
                    opacity: 0.15,
                    marginTop: "-30px",
                    marginLeft: "36px",
                  }}
                ></Box>

                <Stack
                  direction={"row"}
                  gap={2}
                  justifyContent={"space-between"}
                  flexWrap={isSmall ? "wrap-reverse" : "unset"}
                  alignItems={"center"}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      minHeight: "170px",
                      padding: "10px 20px",
                    }}
                  >
                    <Text sx={{ width: "100%" }}>{testimonial.text}</Text>
                    <Rating
                      value={testimonial.rating}
                      readOnly
                      size="large"
                      sx={{
                        mb: 2,
                        color: "#F3EC37",
                        justifyContent: isSmall ? "center" : "unset",
                      }}
                    />
                    <Box
                      sx={{
                        height: "58px",
                        width: "58px",
                        borderRadius: "70px",
                        background: "#FFFFFF",
                        opacity: 0.15,
                        marginBottom: -10,
                        marginLeft: "250px",
                        // marginRight: 10,
                        position: "absolute",
                        bottom: "60px",
                      }}
                    ></Box>
                  </Box>

                  <Box
                    sx={{
                      // width: "auto",
                      overflow: "hidden",
                      height: isSmall ? "auto" : "58vh",
                      width: index === 0 ? "135%" : "100%",
                      padding: "0px 45px",
                      display: isSmall ? "flex" : "unset",
                      flexDirection: isSmall ? "column" : "unset",
                      alignItems: isSmall ? "center" : "unset",
                      justifyContent: isSmall ? "center" : "unset",
                    }}
                  >
                    {!isSmall ? (
                      <Box
                        sx={{
                          height: "1012px",
                          width: "885px",
                          position: "absolute",
                          overflow: "hidden",
                          borderRadius: "1139px",
                          background: "#FFFFFF",
                          opacity: 0.15,
                          marginLeft: "-95px",
                          marginTop: "-74px",
                          padding: "34px",
                          zIndex: 0,
                          clipPath:
                            testimonial?.length > 535
                              ? "inset(0 657px 0 0)"
                              : "inset(0 618px 0 0)",
                          // marginTop: "-30px",
                          // marginLeft: "36px",
                        }}
                      ></Box>
                    ) : null}
                    {/* <Avatar
                      sx={{
                        bgcolor: "#1b5e20",
                        mr: 3,
                        width: "250px",
                        height: "250px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      alt="Super Machinery Store"
                    >
                      <Box
                        sx={{
                          border: "20px solid #CFE6D0",
                          borderRadius: "50%",
                        }}
                      >
                        <img
                          src={testimonial.image}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      </Box>
                    </Avatar> */}
                    <Avatar
                      sx={{
                        bgcolor: "#1b5e20",
                        mr: isSmall ? 0 : 3,
                        mt: isSmall ? 4 : 0,
                        width: isSmall ? "120px" : "150px",
                        height: isSmall ? "120px" : "150px",
                        border: isSmall
                          ? "12px solid #CFE6D0"
                          : "20px solid #CFE6D0", // Add the border styling directly here
                      }}
                      alt="Super Machinery Store"
                      src={testimonial.image} // Use the `src` prop for the image
                    />

                    <Box
                      sx={{
                        // width: "1177px",
                        borderRadius: "60px",
                        // background: "#56A85A",
                      }}
                    >
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Text
                          sx={{
                            fontSize: "20px",
                            color: "#F3EC37",
                            fontWeight: "600",
                            mr: isSmall ? 0 : -2,
                            mt: "13px",
                          }}
                        >
                          {testimonial.company}
                        </Text>
                        <Text
                          sx={{
                            fontSize: "14px",
                            color: "#FFFFFF",
                            fontWeight: "500",
                            mt: 1,
                            textAlign: isSmall ? "center" : "unset",
                          }}
                        >
                          {testimonial.address}
                        </Text>
                        {/* <Text
                          sx={{
                            fontSize: "12px",
                            color: "#FFFFFF",
                            fontStyle: "italic",
                            mt: 1,
                          }}
                        >
                          {testimonial.address}
                        </Text> */}
                      </Box>
                    </Box>
                  </Box>
                </Stack>
              </ItemBox>
            </Box>
          ))}
        </Box>

        {/* Custom Pagination Dots */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            zIndex: 111,
            position: "relative",
          }}
        >
          {testimonials.map((_, index) => (
            <Box
              key={index}
              onClick={() => {
                console.log("Dot clicked:", index);
                // setAutoPlay(false); // Stop autoplay when clicked
                setCurrentIndex(index);
              }}
              sx={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: currentIndex === index ? "#4CAF50" : "#BCBCBC",
                margin: "0 5px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default Testimonials;
